import React from 'react';

import FallbackLoader from '@async-components/FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-MyCasaFakeEngageContent" */'shared-components/components/MyCasaFakeEngage/content'), { fallback: <div className="is-hidden" /> });

